module.exports = __webpack_public_path__ + "img/5-1.e4d8f490.jpg";